export default [
  {
    name: `Diğer`,
    photo: `/images/43-min.png`,
    width: 40,
    depth: 60,
    height: 40,
  },
];
